import { render, staticRenderFns } from "./day-configurator-new.vue?vue&type=template&id=92b6ecf2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92b6ecf2')) {
      api.createRecord('92b6ecf2', component.options)
    } else {
      api.reload('92b6ecf2', component.options)
    }
    module.hot.accept("./day-configurator-new.vue?vue&type=template&id=92b6ecf2&", function () {
      api.rerender('92b6ecf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/day-configurator-new.vue"
export default component.exports